import {AfterViewInit, Component, OnInit} from '@angular/core';
import { Chart, registerables} from 'chart.js';
import {IndicatorsService} from '../../../services/indicators.service';
import {Localiser} from '../../../services/localiser';
import {UserService} from '../../../services/user.service';
import {Navigation} from '../../../services/navigation.service';
import {luminaria} from '../../../models/luminaria';
import {LuminariaService} from '../../../services/luminaria.service';
import {ProyectoService} from "../../../services/proyecto.service";
import {plano} from "../../../models/plano";
import {zona} from "../../../models/zona";
import {PlanoService} from "../../../services/plano.service";
import {ZonaService} from "../../../services/zona.service";
import {AlertaService} from "../../../services/alerta.service";
import {alert} from "../../../models/alert";

@Component({
  selector: 'app-indicators-selection',
  templateUrl: './indicators-selection.component.html',
  styleUrls: ['./indicators-selection.component.css']
})
export class IndicatorsSelectionComponent implements AfterViewInit {

  indicatorNumber: number = 4;

  healthSafetyOpen: boolean = true;
  presenceToday: boolean = true;
  presence: Chart;
  noiseToday: boolean = true;
  noise: Chart;

  kWToday: number = 0;
  kW: Chart;
  co2Today: number = 0;
  co2: Chart;

  luminariaToday: number = 10;
  luminaria: Chart;
  luminarias = [];
  luminariasFiltro = [];
  luminariasReal = [];
  selectedLum: luminaria = null;

  // PRESENCE
  presenciasChart: Chart;
  presencias: Array<alert>;
  presenciasReal: Array<alert>;
  presenciasFilterTime = 1;
  planos: Array<plano>;
  zonas: Array<zona>;
  showZonas = [];
  planoSelected: plano;
  zonaSelected: zona;
  searcherLuminarias: string = "";
  selectedLums: Array<luminaria> = [];

  constructor(public localiser: Localiser, public user: UserService, private indicatorsService: IndicatorsService,
              private navigation: Navigation, private luminariaService: LuminariaService, public proyectoService: ProyectoService,
              private planoService: PlanoService, private zonaService: ZonaService, private alertaService: AlertaService) {
    Chart.register(...registerables);
  }

  ngAfterViewInit(): void {
    this.indicatorNumber = this.indicatorsService.getIndicator();
    if (this.indicatorNumber == 0) {
      this.presenceSensorChart();
      this.noiseSensorChart();
    } else if (this.indicatorNumber == 1) {
      this.kWSensorChart();
      this.co2SensorChart();
    } else if (this.indicatorNumber == 2) {
      this.getLuminarias();
      this.luminariaChart();
    } else if (this.indicatorNumber == 4) {
      this.getPresencias();
      this.getLuminarias();
      this.getPlanos();
      this.getZonas();
      this.presencesChart();
    }
  }

  presenceSensorChart() {
    this.presence = new Chart('left', {
      type: 'bar',
      data: {
        labels: ['8:00','9:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00',
          '17:00','18:00','19:00','20:00','21:00','22:00','23:00','0:00'],
        datasets: [{
          label: 'Presences',
          data: [0,0,5,5,4,0,0,0,0,0,0,0,2,0,0,1,0],
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined'
        }, {
          label: 'Limit',
          data: [0,3,3,3,0,0,0,0,0,0,0,0,1,0,0,0,0],
          backgroundColor: 'rgba(255, 12, 65, 1)',
          borderColor: 'rgba(255, 12, 65, 1)',
          borderWidth: 2,
          stack: 'combined',
          type: 'line'
        }]
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
    this.presenceToday = true;
  }

  changePresenceChart(time: string) {
    if (time == "today") {
      this.presence.data = {
        labels: ['8:00','9:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00',
          '17:00','18:00','19:00','20:00','21:00','22:00','23:00','0:00'],
        datasets: [{
          label: 'Presences',
          data: [0,0,5,5,4,0,0,0,0,0,0,0,2,0,0,1,0],
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined'
        }, {
          label: 'Limit',
          data: [0,
            3,
            3,
            3,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0
          ],
          backgroundColor: 'rgba(255, 12, 65, 1)',
          borderColor: 'rgba(255, 12, 65, 1)',
          borderWidth: 2,
          stack: 'combined',
          type: 'line'
        }]
      };
      this.presenceToday = true;
    } else {
      this.presence.data = {
        labels: ['Monday', 'Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
        datasets: [{
          label: 'Presences',
          data: [4,3,7,5,7,0,1],
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined'
        }, {
          label: 'Limit',
          data: [1,
            2,
            4,
            3,
            1,
            2,
            5
          ],
          backgroundColor: 'rgba(255, 12, 65, 1)',
          borderColor: 'rgba(255, 12, 65, 1)',
          borderWidth: 2,
          stack: 'combined',
          type: 'line'
        }]
      };
      this.presenceToday = false;
    }
    this.presence.update();
  }

  noiseSensorChart() {
    this.noise = new Chart('right', {
      type: 'line',
      data: {
        labels: ['8:00','9:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00',
          '17:00','18:00','19:00','20:00','21:00','22:00','23:00','0:00'],
        datasets: [{
          label: 'Noise',
          data: [63.23,
            88.72,
            105.56,
            60.62,
            88.21,
            103.63,
            61.36,
            86.61,
            105.88,
            64.01,
            87.89,
            108.47,
            60.82,
            60.60,
            63.65,
            64.48,
            63.66],
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined',
          fill: true,
        }, {
          label: 'Limit',
          data: [110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110],
          backgroundColor: 'rgba(255, 12, 65, 1)',
          borderColor: 'rgba(255, 12, 65, 1)',
          borderWidth: 2,
          stack: 'combined',
        }]
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
    this.noiseToday = true;
  }

  changeNoiseChart(time: string) {
    if (time == "today") {
      this.noise.data = {
        labels: ['8:00','9:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00',
          '17:00','18:00','19:00','20:00','21:00','22:00','23:00','0:00'],
        datasets: [{
          label: 'Noise',
          data: [63.23,
            88.72,
            105.56,
            60.62,
            88.21,
            103.63,
            61.36,
            86.61,
            105.88,
            64.01,
            87.89,
            108.47,
            60.82,
            60.60,
            63.65,
            64.48,
            63.66],
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined',
          fill: true,
        }, {
          label: 'Limit',
          data: [110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110],
          backgroundColor: 'rgba(255, 12, 65, 1)',
          borderColor: 'rgba(255, 12, 65, 1)',
          borderWidth: 2,
          stack: 'combined',
          type: 'line'
        }]
      };
      this.noiseToday = true;
    } else {
      this.noise.data = {
        labels: ['8:00','9:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00',
          '17:00','18:00','19:00','20:00','21:00','22:00','23:00','0:00'],
        datasets: [{
          label: 'Noise',
          data: [80.23,
            76.72,
            99.56,
            98.62,
            95.21,
            105.63,
            89.36,
            112.61,
            95.88,
            92.01,
            87.89,
            82.47,
            74.82,
            76.60,
            69.65,
            60.48,
            50.66],
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined',
          fill: true,
        }, {
          label: 'Limit',
          data: [110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110,
            110],
          backgroundColor: 'rgba(255, 12, 65, 1)',
          borderColor: 'rgba(255, 12, 65, 1)',
          borderWidth: 2,
          stack: 'combined',
          type: 'line'
        }]
      };
      this.noiseToday = false;
    }
    this.noise.update();
  }

  changeHealthSafety() {
    if (this.healthSafetyOpen) {
      this.presence.clear();
      this.noise.clear();
      this.healthSafetyOpen = false;
      console.log("true")
    } else {
      console.log("false")
      this.healthSafetyOpen = true;
      this.presenceSensorChart();
      this.noiseSensorChart();
    }
  }

  kWSensorChart() {
    this.kW = new Chart('left', {
      type: 'line',
      data: {
        labels: ['Monday', 'Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
        datasets: [{
          label: 'Scenario 1',
          data: [201.969,
            203.857,
            220.761,
            210.121,
            209.844,
            213.892,
            213.488],
          backgroundColor: '#F2A356',
          borderColor: '#18264F',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }, {
          label: 'Scenario 0',
          data: [345.254,
            342.202,
            346.036,
            335.178,
            315.163,
            306.010,
            339.241],
          backgroundColor: '#5EFA20',
          borderColor: '#FF0C41',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }]
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
    this.kWToday = 0;
  }

  changekWChart(time: string) {
    if (time == "today") {
      this.kW.data = {
        labels: ['Monday', 'Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
        datasets: [{
          label: 'Scenario 1',
          data: [201.969,
            203.857,
            220.761,
            210.121,
            209.844,
            213.892,
            213.488],
          backgroundColor: '#F2A356',
          borderColor: '#18264F',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }, {
          label: 'Scenario 0',
          data: [345.254,
            342.202,
            346.036,
            335.178,
            315.163,
            306.010,
            339.241],
          backgroundColor: '#5EFA20',
          borderColor: '#FF0C41',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }]
      };
      this.kWToday = 0;
    } else if (time == "week") {
      this.kW.data = {
        labels: ['Monday', 'Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
        datasets: [{
          label: 'Scenario 1',
          data: [220.542,
            209.932,
            211.691,
            210.838,
            204.898,
            205.287,
            212.942],
          backgroundColor: '#F2A356',
          borderColor: '#18264F',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }, {
          label: 'Scenario 0',
          data: [306.483,
            339.385,
            324.464,
            306.977,
            301.761,
            314.263,
            308.851],
          backgroundColor: '#5EFA20',
          borderColor: '#FF0C41',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }]
      };
      this.kWToday = 1;
    } else {
      this.kW.data = {
        labels: ['01/06','02/06','03/06','04/06','05/06','06/06','07/06',
          '08/06','08/06','10/06','11/06','12/06','13/06','14/06','15/06',
          '16/06','17/06','18/06','19/06','20/06','21/06','22/06','23/06',
          '24/06','25/06','26/06','27/06','28/06','29/06','30/06'],
        datasets: [{
          label: 'Scenario 1',
          data: [217.321,
            214.564,
            203.376,
            212.493,
            208.934,
            201.950,
            218.744,
            205.236,
            211.376,
            216.670,
            200.403,
            200.836,
            201.346,
            209.386,
            221.495,
            207.180,
            205.338,
            203.636,
            203.475,
            199.591,
            222.641,
            211.420,
            204.720,
            205.229,
            220.032,
            219.821,
            198.032,
            198.413,
            210.448,
            219.539],
          backgroundColor: '#F2A356',
          borderColor: '#18264F',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }, {
          label: 'Scenario 0',
          data: [343.528,
            323.322,
            300.099,
            330.826,
            322.642,
            321.928,
            341.572,
            343.147,
            334.679,
            302.075,
            326.714,
            347.461,
            320.391,
            320.186,
            331.761,
            330.313,
            345.936,
            318.392,
            349.206,
            318.636,
            347.472,
            318.587,
            314.919,
            337.317,
            340.519,
            335.063,
            329.209,
            325.588,
            341.958,
            323.828],
          backgroundColor: '#5EFA20',
          borderColor: '#FF0C41',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }]
      };
      this.kWToday = 2;
    }
    this.kW.update();
  }

  co2SensorChart() {
    this.co2 = new Chart('right', {
      type: 'line',
      data: {
        labels: ['Monday', 'Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
        datasets: [{
          label: 'Scenario 1',
          data: [13.583,
            13.410,
            12.711,
            13.281,
            13.058,
            12.622,
            13.671],
          backgroundColor: '#18264F',
          borderColor: '#5AAD00',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }, {
          label: 'Scenario 0',
          data: [21.470,
            20.208,
            18.756,
            20.677,
            20.165,
            20.121,
            21.348],
          backgroundColor: '#5EFA20',
          borderColor: '#FF0C41',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }]
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
    this.co2Today = 0;
  }

  changeCO2Chart(time: string) {
    if (time == "today") {
      this.co2.data = {
        labels: ['Monday', 'Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
        datasets: [{
          label: 'Scenario 1',
          data: [13.583,
            13.410,
            12.711,
            13.281,
            13.058,
            12.622,
            13.671],
          backgroundColor: '#18264F',
          borderColor: '#5AAD00',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }, {
          label: 'Scenario 0',
          data: [21.470,
            20.208,
            18.756,
            20.677,
            20.165,
            20.121,
            21.348],
          backgroundColor: '#5EFA20',
          borderColor: '#FF0C41',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }]
      };
      this.co2Today = 0;
    } else if (time == "week") {
      this.co2.data = {
        labels: ['Monday', 'Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
        datasets: [{
          label: 'Scenario 1',
          data: [12.827,
            13.211,
            13.542,
            12.525,
            12.552,
            12.584,
            13.087],
          backgroundColor: '#18264F',
          borderColor: '#5AAD00',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }, {
          label: 'Scenario 0',
          data: [21.447,
            20.917,
            18.880,
            20.420,
            21.716,
            20.024,
            20.012],
          backgroundColor: '#5EFA20',
          borderColor: '#FF0C41',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }]
      };
      this.co2Today = 1;
    } else {
      this.co2.data = {
        labels: ['01/06','02/06','03/06','04/06','05/06','06/06','07/06',
          '08/06','08/06','10/06','11/06','12/06','13/06','14/06','15/06',
          '16/06','17/06','18/06','19/06','20/06','21/06','22/06','23/06',
          '24/06','25/06','26/06','27/06','28/06','29/06','30/06'],
        datasets: [{
          label: 'Scenario 1',
          data: [13.583,
            13.410,
            12.711,
            13.281,
            13.058,
            12.622,
            13.671,
            12.827,
            13.211,
            13.542,
            12.525,
            12.552,
            12.584,
            13.087,
            13.843,
            12.949,
            12.834,
            12.727,
            12.717,
            12.474,
            13.915,
            13.214,
            12.795,
            12.827,
            13.752,
            13.739,
            12.377,
            12.401,
            13.153,
            13.721],
          backgroundColor: '#18264F',
          borderColor: '#5AAD00',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }, {
          label: 'Scenario 0',
          data: [21.470,
            20.208,
            18.756,
            20.677,
            20.165,
            20.121,
            21.348,
            21.447,
            20.917,
            18.880,
            20.420,
            21.716,
            20.024,
            20.012,
            20.735,
            20.645,
            21.621,
            19.899,
            21.825,
            19.915,
            21.717,
            19.912,
            19.682,
            21.082,
            21.282,
            20.941,
            20.576,
            20.349,
            21.372,
            20.239],
          backgroundColor: '#5EFA20',
          borderColor: '#FF0C41',
          borderWidth: 2,
          stack: 'combined',
          fill: true
        }]
      };
      this.co2Today = 2;
    }
    this.co2.update();
  }

  getLuminarias() {
    this.luminariaService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((response: any) => {
      this.luminariasReal = response;
      this.luminariasFiltro = this.luminariasReal;
      this.luminarias = this.luminariasFiltro;
      this.searcherLuminariasFunc();
      this.changePresenciasFilterTime(this.presenciasFilterTime);
      /*let lArray: Array<luminaria> = <Array<luminaria>> response;
      for (let l of lArray) {
        if (l.idDispositivo != "70FEC4FEFF19276A") {
          console.log(l.idDispositivo)
          this.luminarias.push(l);
        }
      }
      if (this.luminarias.length != 0) {
        this.selectLum(this.luminarias[0]);
      }
      console.log(this.luminarias)*/
    });

  }

  selectLum(luminaria: luminaria) {
    this.luminariaService.getByID(luminaria.idDispositivo, true).subscribe(response => {
      this.selectedLum = <luminaria> response;
      console.log(this.selectedLum);
      this.changeLuminariaChart(this.luminariaToday);
    });
  }

  luminariaChart() {
    this.luminaria = new Chart('right', {
      type: 'bar',
      data: {
        labels: ['1','2','3','4','5','6','7','8','9','10'],
        datasets: [{
          label: 'mWh',
          data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined'
        }, {
          label: 'ºC',
          data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
          backgroundColor: 'rgba(255, 12, 65, 1)',
          borderColor: 'rgba(255, 12, 65, 1)',
          borderWidth: 2,
          stack: 'combined',
          type: 'line'
        }]
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
    this.luminariaToday = 10;
  }

  changeLuminariaChart(n: number) {
    let labels = [];
    if (n == 10) {
      labels = ['1','2','3','4','5','6','7','8','9','10'];
    } else if (n == 20) {
      labels = ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20'];
    } else if (n == 30) {
      labels = ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20',
        '21','22','23','24','25','26','27','28','29','30'];
    }
      this.luminaria.data = {
        labels: labels,
        datasets: [{
          label: 'mWh',
          data: this.getArraymWhFromDaliData(n, this.selectedLum),
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined'
        }, {
          label: 'ºC',
          data: this.getArrayTempFromDaliData(n, this.selectedLum),
          backgroundColor: 'rgba(255, 12, 65, 1)',
          borderColor: 'rgba(255, 12, 65, 1)',
          borderWidth: 2,
          stack: 'combined',
          type: 'line'
        }]
      };
    this.luminariaToday = n;
    this.luminaria.update();
  }

  public getArraymWhFromDaliData(n: number, luminaria) {
    let array: number[] = [];
    let i = 0;
    for (let data of luminaria.daliDataList) {
      array.push(data.w / 1000);
      i++;
      if (i == n) {
        break;
      }
    }
    return array;
  }

  public getArrayTempFromDaliData(n: number, luminaria) {
    let array: number[] = [];
    let i = 0;
    for (let data of luminaria.daliDataList) {
      array.push(data.cg_TEMP);
      i++;
      if (i == n) {
        break;
      }
    }
    return array;
  }

  getPresencias() {
    this.alertaService.getPresenciasByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<alert>) => {
      this.presenciasReal = result;
      this.presencias = this.presenciasReal;
      console.log(this.presencias)
    });
  }

  getPlanos() {
    this.planoService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<plano>) => {
      this.planos = result;
    })
  }

  getZonas() {
    this.zonaService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<zona>) => {
      this.zonas = result;
    })
  }

  selectPlano(planoEv) {
    if (planoEv == -1) {
      this.planoSelected = undefined;
      this.zonaSelected = undefined;
      this.luminariasFiltro = this.luminariasReal;
      this.luminarias = this.luminariasFiltro;
      this.searcherLuminariasFunc();
    } else {
      this.planoSelected = this.planos.find(plano => plano.idPlano == planoEv.idPlano);
      this.zonaSelected = undefined;
      this.showZonas = this.zonas.filter(zona => {
        return zona.idPlano == this.planoSelected.idPlano;
      });
      this.luminariasFiltro = this.luminariasReal.filter(luminaria => luminaria.idPlano == planoEv.idPlano);
      this.luminarias = this.luminariasFiltro;
      this.searcherLuminariasFunc();
    }
  }

  selectZona(zonaEv) {
    if (zonaEv == -1) {
      this.zonaSelected = undefined;
      this.selectPlano(this.planoSelected)
    } else {
      this.zonaSelected = this.showZonas.find(zona => zona.id == zonaEv.id);
      this.luminariasFiltro = this.luminariasReal.filter(luminaria => luminaria.idZona == zonaEv.id);
      this.luminarias = this.luminariasFiltro;
      this.searcherLuminariasFunc();
    }
  }

  searcherLuminariasFunc() {
    this.luminarias = this.luminariasFiltro.filter(luminaria =>
      (luminaria.nombre.toLowerCase().includes(this.searcherLuminarias.toLowerCase())) ||
      (luminaria.idDispositivo.toLowerCase().includes(this.searcherLuminarias.toLowerCase())));
    this.selectedLums = [];
    this.luminarias.forEach(lum => this.selectedLums.push(lum));
    this.reloadChart();
    console.log(this.luminarias)
  }

  filterPresenciasBySelectedLum(presencias) {
    return presencias.filter(pres => this.selectedLums.some(lum => lum.idDispositivo == pres.idDispositivo));
  }

  relationPresenciasLuminarias() {
    for (let luminaria of this.luminariasReal) {
      luminaria.presencias = this.presencias.
      filter(presencia => presencia.idDispositivo == luminaria.idDispositivo).length;
    }
    for (let luminaria of this.luminarias) {
      luminaria.presencias = this.luminariasReal.find(lum => lum.idDispositivo == luminaria.idDispositivo).presencias;
    }
  }

  setPresenciasToday() {
    let today: Date = new Date();
    //let today: Date = new Date(1658230575000);
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    //let hours = (new Date(1658250975000).getTime() - today.getTime()) / 3600000;
    let hours = (new Date().getTime() - today.getTime()) / 3600000;
    let labels = [];
    let data = [];
    for (let i = 0; i < hours; i++) {
      labels.push(i+':00')
      data.push(this.filterPresenciasBySelectedLum(this.presencias).filter(pres =>
        ((pres.timeLastCom * 1000) >= today.getTime()) &&
        ((pres.timeLastCom * 1000) < (today.getTime() + 3600000))).length);
      today.setTime(today.getTime() + 3600000);
    }
    this.changePresenciasChart(labels, data);
    console.log(data)
  }

  filterPresenciasToday() {
    //let today: Date = new Date(1658230575000);
    let today: Date = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    this.presencias = this.presenciasReal.filter(pres =>
      ((pres.timeLastCom * 1000) >= today.getTime()) &&
      ((pres.timeLastCom * 1000) < (today.getTime() + 86400000)));
    this.setPresenciasToday();
  }

  setPresenciasYesterday() {
    let today: Date = new Date();
    //let today: Date = new Date(1657721179000);
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    let yesterday: Date = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0);
    yesterday.setMinutes(0);
    yesterday.setSeconds(0);
    //let hours = (new Date(1657741179000).getTime() - today.getTime()) / 3600000;
    console.log(today)
    console.log(yesterday)
    let hours = (today.getTime() - yesterday.getTime()) / 3600000;
    console.log(hours)
    let labels = [];
    let data = [];
    for (let i = 0; i < hours; i++) {
      labels.push(i+':00')
      data.push(this.filterPresenciasBySelectedLum(this.presencias).filter(pres =>
        ((pres.timeLastCom * 1000) >= yesterday.getTime()) &&
        ((pres.timeLastCom * 1000) < (yesterday.getTime() + 3600000))).length);
      yesterday.setTime(yesterday.getTime() + 3600000);
    }
    this.changePresenciasChart(labels, data);
    console.log(data)
  }

  filterPresenciasYesterday() {
    //let today: Date = new Date(1657721179000);
    let today: Date = new Date();
    today.setDate(today.getDate() - 1);
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    this.presencias = this.presenciasReal.filter(pres =>
      ((pres.timeLastCom * 1000) >= today.getTime()) &&
      ((pres.timeLastCom * 1000) < (today.getTime() + 86400000)));
    this.setPresenciasYesterday();
  }

  setPresenciasWeek() {
    let today: Date = new Date();
    //let today: Date = new Date(1658230575000);
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setTime(today.getTime() - (86400000 * 6));
    //let hours = (new Date(1658250975000).getTime() - today.getTime()) / 86400000;
    let hours = (new Date().getTime() - today.getTime()) / 86400000;
    let labels = [];
    let data = [];
    for (let i = 0; i < hours; i++) {
      labels.push(today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear())
      data.push(this.filterPresenciasBySelectedLum(this.presencias).filter(pres =>
        ((pres.timeLastCom * 1000) >= today.getTime()) &&
        ((pres.timeLastCom * 1000) < (today.getTime() + 86400000))).length);
      today.setTime(today.getTime() + 86400000);
    }
    this.changePresenciasChart(labels, data);
    console.log(data)
  }

  filterPresenciasWeek() {
    let today: Date = new Date();
    //let today: Date = new Date(1658230575000);
    today.setDate(today.getDate() - 6);
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    this.presencias = this.presenciasReal.filter(pres =>
      ((pres.timeLastCom * 1000) >= today.getTime()) &&
      ((pres.timeLastCom * 1000) < (today.getTime() + (86400000 * 7))));
    this.setPresenciasWeek();
  }

  setPresenciasMonth() {
    let today: Date = new Date();
    //let today: Date = new Date(1659085442000);
    today.setTime(today.getTime() - (86400000 * 30));
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    let hours = (new Date().getTime() - today.getTime()) / 86400000;
    //let hours = (new Date(1659085442000).getTime() - today.getTime()) / 86400000;
    let labels = [];
    let data = [];
    for (let i = 0; i < hours; i++) {
      labels.push(today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear())
      data.push(this.filterPresenciasBySelectedLum(this.presencias).filter(pres =>
        ((pres.timeLastCom * 1000) >= today.getTime()) &&
        ((pres.timeLastCom * 1000) < (today.getTime() + 86400000))).length);
      today.setTime(today.getTime() + 86400000);
    }
    this.changePresenciasChart(labels, data);
    console.log(data)
  }

  filterPresenciasMonth() {
    let today: Date = new Date();
    //let today: Date = new Date(1659085442000);
    today.setTime(today.getTime() - (86400000 * 30));
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    this.presencias = this.presenciasReal.filter(pres =>
      ((pres.timeLastCom * 1000) >= today.getTime()) &&
      ((pres.timeLastCom * 1000) < (today.getTime() + (86400000 * 31))));
    this.setPresenciasMonth();
  }

  setPresenciasYear() {
    //let today: Date = new Date();
    let today: Date = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setDate(1);
    today.setFullYear(today.getFullYear() - 1);
    today.setMonth(today.getMonth() + 1)
    let months = 12;
    let labels = [];
    let data = [];
    let nextMonth: Date = new Date(today.getTime());
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    for (let i = 0; i < months; i++) {
      labels.push((today.getMonth() + 1) + "/" + today.getFullYear())
      data.push(this.filterPresenciasBySelectedLum(this.presencias).filter(pres =>
        ((pres.timeLastCom * 1000) >= today.getTime()) &&
        ((pres.timeLastCom * 1000) < nextMonth.getTime())).length);
      today.setMonth(today.getMonth() + 1)
      nextMonth.setMonth(nextMonth.getMonth() + 1);
    }
    this.changePresenciasChart(labels, data);
    console.log(data)
  }

  filterPresenciasYear() {
    let today: Date = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setDate(1);
    today.setFullYear(today.getFullYear() - 1);
    today.setMonth(today.getMonth() + 1)
    this.presencias = this.presenciasReal.filter(pres =>
      ((pres.timeLastCom * 1000) >= today.getTime()) &&
      ((pres.timeLastCom * 1000) < (new Date().getTime())));
    this.setPresenciasYear();
  }

  changePresenciasChart(labels, data) {
    this.presenciasChart.data = {
      labels: labels,
      datasets: [{
        label: 'Presences',
        data: data,
        backgroundColor: 'rgba(24, 38, 79, 0.25)',
        borderColor: 'rgba(24, 38, 79, 1)',
        borderWidth: 1,
        stack: 'combined'
      }]
    }
    this.presenciasChart.update();
  }

  changePresenciasFilterTime(n: number) {
    this.presenciasFilterTime = n;
    if (n == 1) {
      this.filterPresenciasToday();
    } else if (n == 2) {
      this.filterPresenciasYesterday();
    } else if (n == 3) {
      this.filterPresenciasWeek();
    } else if (n == 4) {
      this.filterPresenciasMonth();
    } else if (n == 5) {
      this.filterPresenciasYear();
    }
    this.relationPresenciasLuminarias();
  }

  changeSelectLum(luminaria: luminaria) {
    if (this.checkSelectedLuminaria(luminaria)) {
      this.selectedLums.splice(this.selectedLums.findIndex(lum => lum.idDispositivo == luminaria.idDispositivo), 1);
    } else {
      this.selectedLums.push(luminaria);
    }
    this.reloadChart();
  }

  checkSelectedLuminaria(luminaria) {
    return this.selectedLums.find(lum => lum.idDispositivo == luminaria.idDispositivo) != undefined;
  }

  reloadChart() {
    this.changePresenciasFilterTime(this.presenciasFilterTime);
  }

  presencesChart() {
    this.presenciasChart = new Chart('presenciasChart', {
      type: 'bar',
      data: {
        labels: [],
        datasets: [{
          label: 'Presences',
          data: [],
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined'
        }]
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
    this.presenceToday = true;
  }

  toIndicators() {
    this.navigation.toIndicators();
  }

  toLocations() {
    this.navigation.toLocations();
  }

}
